module.exports = new __parcel__URL__("GetTheDetailsYouNeedDark.bbe9839d.gif").toString();